/* src/app/ai-sourcing/ai-sourcing-profiles/ai-sourcing-profiles.component.scss */
p.isActive {
  color: #2e93a1 !important;
}
.count-circle {
  background-color: rgba(150, 150, 150, 0.1019607843);
  border-radius: 50%;
  font-size: 10px;
  color: #969696;
  margin-left: 6px;
  font-weight: 600;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tab {
  border-bottom: 2px solid #fff;
}
span.isActive {
  color: #2e93a1 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #2e93a1;
  display: flex;
  align-items: center;
  justify-content: center;
}
span.isActive .count-circle {
  background-color: rgba(46, 147, 161, 0.1019607843);
  color: #2e93a1;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: transparent;
  color: #2C2C2C;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #206C79;
  border-radius: 0px;
  font-weight: 500;
  background-color: transparent;
  border-bottom: 2px solid #206C79;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
.archive {
  color: rgba(205, 15, 15, 0.5411764706) !important;
  border-color: rgba(205, 15, 15, 0.5411764706) !important;
  transition: all 0.4s ease-in-out;
}
.archive:hover {
  background-color: rgba(250, 221, 221, 0.5411764706);
}
.btn-trms-small {
  background-color: #ffffff;
  color: #2e93a1;
}
.text-color {
  color: #2e93a1 !important;
}
[class^=btn-trms-] {
  font-size: 12px !important;
  padding: 7px 14px !important;
}
.w-60 {
  width: 52%;
}
.ai-sourcing-alert {
  border-radius: 8px;
  background: #E4F1F3;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  max-width: auto;
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  border: 1px solid transparent;
  border-radius: 2px;
  left: 0%;
  right: 0%;
  top: 90px;
  margin: 0 auto;
  font-size: 12px;
  z-index: 1;
  color: #2E93A1;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}
.close-alert {
  color: #2E93A1;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  margin-left: 15px;
}
.circular-progress {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: conic-gradient(#2E93A1 var(--value, 0%), #e0e0e0 0);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.progress-text {
  font-size: 14px;
  font-weight: 500;
  color: #2E93A1;
  min-width: 35px;
}
.progress-container {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
}
.circular-progress {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 8px;
}
.circular-progress svg {
  transform: rotate(-90deg);
}
.circular-progress-bg {
  fill: none;
  stroke: #e9ecef;
  stroke-width: 3;
}
.circular-progress-fill {
  fill: none;
  stroke: #2E93A1;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
}
.status-btn {
  padding: 0 6px 0 6px;
  border-radius: 3px;
}
.live-status {
  background-color: #dcf3d1;
  color: #229300;
  font-size: 14px;
  font-weight: 500;
}
.disable-tab {
  opacity: 0.5;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
}
.toggle-container .activebtn {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 11px;
  font-weight: 600;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 11px;
  font-weight: 500;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
/*# sourceMappingURL=ai-sourcing-profiles.component-LKF7422P.css.map */
